import { useState, useRef, useEffect } from "react"
import { useDispatch } from "react-redux";
import { Card, Box } from "@mui/material"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDInput from "components/MDInput"
import MDButton from "components/MDButton"
import BasicLayout from "layouts/authentication/components/BasicLayout"
import bgImage from "assets/images/bg.jpg"
import logo from "assets/images/logowebrapor.png"
import { AuthenticationAPI } from "API/AuthenticationAPI"
import { checkResponse, alertErrorText } from 'helpers/notification'
import { Navigate, useNavigate } from "react-router-dom"
import useAuth from "helpers/useAuth"
import preval from 'preval.macro'
import jwtDecode from "jwt-decode";
import Swal from 'sweetalert2'
import moment from 'moment';
import { setCodecToken, setVerifiedEntityLevel } from "features/commonSlice";
import { useLocation } from "react-router-dom";

function Login() {

  const { isAuthenticated } = useAuth();

  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');

  const ref = useRef(null);
  const [width, setWidth] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    var twoFaTransactionId = params.get("twofati")
    var verifiedEntityLevel = params.get("verifiedEntityLevel")
    if (twoFaTransactionId) {
      getTokenFromTwoFaTransactionId(twoFaTransactionId, verifiedEntityLevel);
    }

    var resultCode = params.get("resultCode");
    if (resultCode) {
      alertErrorText("Hata Kodu : " + params.get("resultCode") + "\n Hata Açıklaması : " + params.get("resultDescription"));
    }

  }, [location.search]);

  const getTokenFromTwoFaTransactionId = async (twoFaTransactionId, verifiedEntityLevel) => {
    const getTokenFromTwoFaTransactionIdResponse = await AuthenticationAPI.GetTokenFromTwoFaTransactionId(twoFaTransactionId);

    if (checkResponse(getTokenFromTwoFaTransactionIdResponse, null, '2FA işlemi başarısız oldu.Lütfen Tekrar deneyin.')) {

      var auth = null;
      if (getTokenFromTwoFaTransactionIdResponse.data.resultObject !== null) {
        try {
          auth = jwtDecode(getTokenFromTwoFaTransactionIdResponse.data.resultObject);
        } catch (e) {
          auth = null;
        }
      }

      dispatch(setCodecToken(getTokenFromTwoFaTransactionIdResponse.data.resultObject));
      dispatch(setVerifiedEntityLevel(verifiedEntityLevel));

      const isUserPopupShowResponse = await AuthenticationAPI.IsUserPopupShow(auth.UserName);

      if (!isUserPopupShowResponse.data.resultObject) {

        await AuthenticationAPI.InsertUserPopupShow(auth.UserName, moment(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSSZ'));
        Swal.fire({
          html: `
    <style>
      @keyframes pulse {
        0% { opacity: 1; }
        50% { opacity: 0.4; }
        100% { opacity: 1; }
      }

      .alert-title {
        font-size: 20px;
        font-weight: 700;
        color: #1f6cd7;
        text-align: center;
        margin-bottom: 12px;
        animation: pulse 1.4s infinite;
      }
    </style>

    <div class="alert-title"> WebRapor Yenilendi</div>

    <div style="text-align:left;font-size:14px;line-height:1.6">
      <p><strong>Değerli Müşterimiz,</strong></p>

      <p>
        WebRapor yenileme çalışmaları kapsamında bazı önemli geliştirmeler
        kullanımınıza sunulmuştur;
      </p>

      <ul style="padding-left:18px">
        <li>WebRapor girişlerinde <strong>2FA (İki Faktörlü Doğrulama)</strong> zorunlu hale getirilmiştir.</li>
        <li>Kullanıcı yetki ve erişim bilgilerini görüntüleyebileceğiniz <strong>Anasayfa</strong> eklenmiştir.</li>
        <li>
          WebRapor erişimi ve 2FA doğrulaması için gerekli
          <strong>kullanıcı ve yetkili telefon numarası</strong> bilgilerinin,
          <strong>Kullanıcı Yönetimi</strong> ekranı üzerinden tanımlanması ve güncel tutulması gerekmektedir.
        </li>
      </ul>

      <p style="margin-top:10px">
        Sorunsuz kullanım için bilgilerinizi kontrol etmenizi rica ederiz.
      </p>
    </div>
  `,
          confirmButtonText: "Anladım",
          icon: "info"
        });


      }

      let locationPathname = localStorage.getItem('locationPathname');
      navigate(
        locationPathname && locationPathname.trim() !== ""
          ? locationPathname
          : "/",
        { replace: true }
      );

    }
  }

  const login = async (e) => {
    localStorage.removeItem('locationPathname');

    if (userName === '') {
      alertErrorText('Kullanıcı Adı Giriniz!');
      return;
    }

    if (password === '') {
      alertErrorText('Şifre Giriniz');
      return;
    }

    const userLoginResponse = await AuthenticationAPI.UserLogin(userName, password);

    if (checkResponse(userLoginResponse, null, 'Giriş işlemi başarısız oldu.Lütfen Tekrar deneyin.')) {
      if (userLoginResponse.data.resultObject.resultCode === '-1') {
        alertErrorText("Şifre hatalı");
      }
      else if (userLoginResponse.data.resultObject.resultCode === '-2') {
        alertErrorText("Kullanıcı bulunamadı");
      }
      else if (userLoginResponse.data.resultObject.resultCode === '') {
        alertErrorText("İşlem sırasında sunucuda bir hata oluştu! Lütfen tekrar deneyin.");
      }
      else {
        var auth = null;
        const token = userLoginResponse.data.resultObject.token;

        if (token !== null) {
          try {
            auth = jwtDecode(token);
          } catch (e) {
            auth = null;
          }
        }

        if (!auth) {
          alertErrorText("Token çözümlenemedi.");
          return;
        }

        const isTwoFactorRequired = auth.IsTwoFactor === true || auth.IsTwoFactor === "True" || auth.IsTwoFactor === "true";

        // 2FA bypass ise direkt login tamamla
        if (!isTwoFactorRequired) {
          dispatch(setCodecToken(token));
          dispatch(setVerifiedEntityLevel("None"));

          const isUserPopupShowResponse = await AuthenticationAPI.IsUserPopupShow(auth.UserName);

          if (!isUserPopupShowResponse.data.resultObject) {
            await AuthenticationAPI.InsertUserPopupShow(auth.UserName, moment(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSSZ'));

            Swal.fire({
              html: `
              <style>
                @keyframes pulse {
                  0% { opacity: 1; }
                  50% { opacity: 0.4; }
                  100% { opacity: 1; }
                }

                .alert-title {
                  font-size: 20px;
                  font-weight: 700;
                  color: #1f6cd7;
                  text-align: center;
                  margin-bottom: 12px;
                  animation: pulse 1.4s infinite;
                }
              </style>

              <div class="alert-title"> WebRapor Yenilendi</div>

              <div style="text-align:left;font-size:14px;line-height:1.6">
                <p><strong>Değerli Müşterimiz,</strong></p>

                <p>
                  WebRapor yenileme çalışmaları kapsamında bazı önemli geliştirmeler
                  kullanımınıza sunulmuştur;
                </p>

                <ul style="padding-left:18px">
                  <li>WebRapor girişlerinde <strong>2FA (İki Faktörlü Doğrulama)</strong> zorunlu hale getirilmiştir.</li>
                  <li>Kullanıcı yetki ve erişim bilgilerini görüntüleyebileceğiniz <strong>Anasayfa</strong> eklenmiştir.</li>
                  <li>
                    WebRapor erişimi ve 2FA doğrulaması için gerekli
                    <strong>kullanıcı ve yetkili telefon numarası</strong> bilgilerinin,
                    <strong>Kullanıcı Yönetimi</strong> ekranı üzerinden tanımlanması ve güncel tutulması gerekmektedir.
                  </li>
                </ul>

                <p style="margin-top:10px">
                  Sorunsuz kullanım için bilgilerinizi kontrol etmenizi rica ederiz.
                </p>
              </div>
            `,
              confirmButtonText: "Anladım",
              icon: "info"
            });
          }

          let locationPathname = localStorage.getItem('locationPathname');
          navigate(
            locationPathname && locationPathname.trim() !== ""
              ? locationPathname
              : "/",
            { replace: true }
          );

          return;
        }

        // 2FA gerekiyorsa mevcut akış devam etsin
        const redirectTo2FAResponse = await AuthenticationAPI.RedirectTo2FA(
          auth.GroupId >= 0,
          auth.UserName,
          auth.TwoFaTransactionId
        );

        if (checkResponse(redirectTo2FAResponse, null, '2FA işlemi başarısız oldu.Lütfen Tekrar deneyin.')) {
          window.location.replace(redirectTo2FAResponse.data.resultObject);
        }
      }
    }
  }

  useEffect(() => {
    if (!isAuthenticated)
      setWidth(ref.current.offsetWidth);
  }, []);

  return (
    <>
      {!isAuthenticated ? (
        <BasicLayout image={bgImage}>
          <Card>
            <MDBox
              ref={ref}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              mx={2}
              mt={-3}
              p={2}
              mb={1}
              textAlign="center"
            >
              <Box
                sx={{
                  width: width - 70

                }}
                component="img"
                src={logo}
              />

            </MDBox>
            <MDBox pt={4} pb={3} px={3}>
              <MDBox component="form" role="form">
                <MDBox mb={2}>
                  <MDInput type="email" label="Kullanıcı Adı" fullWidth value={userName} onChange={e => setUserName(e.target.value)} />
                </MDBox>
                <MDBox mb={2}>
                  <MDInput type="password" label="Şifre" fullWidth value={password} onChange={e => setPassword(e.target.value)} />
                </MDBox>
                <MDBox display="flex" alignItems="center" ml={-1}>

                  <MDTypography
                    variant="caption"
                    color="text"
                    verticalAlign="middle"
                  >
                    © {new Date().getFullYear()} - CODEC İletişim ve Danışmanlık Hizmetleri Ltd. Şti. Version {preval`module.exports = new Date().toLocaleString();`}
                  </MDTypography>
                </MDBox>
                <MDBox mt={4} mb={1}>
                  <MDButton variant="gradient" color="info" fullWidth onClick={login}>
                    Giriş Yap
                  </MDButton>
                </MDBox>
              </MDBox>
            </MDBox>
          </Card>
        </BasicLayout>
      ) : (
        <Navigate to={(localStorage.getItem("locationPathname") || "/").trim() || "/"} replace />

      )}
    </>

  );
}

export default Login;
